import React from 'react';
import { Modal, Button, Select, message } from 'antd';
import { translate } from 'react-i18next';
const Option = Select.Option;

class ModalSubject extends React.Component {

  state = {
    subjectName: "",
    subjectCategory: ""
  }

  saveModal = () => {
    if (this.state.subjectName !== "" && this.state.subjectCategory !== "") {
      this.props.save(this.state)
    } else {
      message.warning('Both fields are mandatory!');
    }
  }

  cancel = () => {
    this.setState({subjectName: "", subjectCategory: ""})
    this.props.close()
  }

  render() {

    const t = this.props.t
    const subject_categories = this.props.subject_categories && Object.entries(this.props.subject_categories)

    return (
      <div>
        <Modal
          className="edituser"
          visible={this.props.open}
          onOk={this.saveModal}
          onCancel={this.cancel}
          okText={t('Ok')}
          cancelText={t('Cancel')}
        >
          <h3 style={{marginTop:20}}>{t('Subject category')}</h3>
          <Select value={this.state.subjectCategory} style={{ width: '100%' }} onChange={(value) => this.setState({subjectCategory: value})}>
            {subject_categories && subject_categories.map( category => (
              <Option value={category[0]}>{t(category[1].name)}</Option>
            ))}
          </Select>
          <h3 style={{marginTop:20}}>{t('Subject Name')}</h3>
          <input style={{paddingLeft:10 }} type="text" value={this.state.subjectName} onChange={(e) => this.setState({subjectName: e.target.value})} />
        </Modal>
      </div>
    )
  }
}

export default ModalSubject;



// WEBPACK FOOTER //
// ./src/components/ModalSubject/index.jsx